export default class PurchasedProduct {
  uuid?: string
  purchased_quantity: number
  number_accessors_used: number

  constructor(props: PurchasedProduct) {
    this.uuid = props.uuid
    this.purchased_quantity = props?.purchased_quantity || 0
    this.number_accessors_used = props?.number_accessors_used || 0
  }
}
